<template>
  <div>
    <JsonEditor v-model="eventHandler" />
    <button @click="createEventHandler(eventHandler)">
      Create
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

export default {
  name: 'EventHandlerCreate',
  data() {
    return {
      eventHandler: {
        name: null,
        event: 'conductor:<queue_name>',
        actions: [
          {
            action: 'start_workflow',
            start_workflow: {
              name: '<workflow_name>',
              version: '<optional>',
              input: {
                param1: '${param1}'
              }
            }
          }
        ]
      }
    }
  },
  methods: mapActions(['createEventHandler']),
  components: {
    JsonEditor
  }
}
</script>
